var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-banner"},[_c('div',{staticClass:"service-banner-img",style:({backgroundImage:'url('+_vm.imgUrl+')'})}),_vm._v(" "),_c('div',{staticClass:"title1"},[_vm._v(_vm._s(_vm.title1)),_c('span',{staticClass:"title-en"},[_vm._v(_vm._s(_vm.titleEn))])]),_vm._v(" "),_c('div',{staticClass:"title2"},[_vm._v(_vm._s(_vm.title2))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12279e1b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CBanner.vue
// module id = null
// module chunks = 